import { render, staticRenderFns } from "./LanguageData.vue?vue&type=template&id=bfdfbf2e&scoped=true"
import script from "./LanguageData.vue?vue&type=script&lang=js"
export * from "./LanguageData.vue?vue&type=script&lang=js"
import style0 from "./LanguageData.vue?vue&type=style&index=0&id=bfdfbf2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdfbf2e",
  null
  
)

export default component.exports